import { Check } from "lucide-react";

/**
 * Premium chip-based multi-select.
 * Touch-friendly (min 44x44 hit area), animated, fully accessible.
 */
export default function MultiInterestSelector({
  options,
  value = [],
  onChange,
  label = "What are you drawn to? (pick as many as you like)",
  required = false,
  testIdPrefix = "interest",
  max = null,
}) {
  const toggle = (opt) => {
    if (value.includes(opt)) {
      onChange(value.filter((v) => v !== opt));
    } else {
      if (max && value.length >= max) return;
      onChange([...value, opt]);
    }
  };

  const slug = (s) =>
    s
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

  return (
    <div data-testid={`${testIdPrefix}-multi`}>
      <p className="text-[10px] uppercase tracking-[0.32em] font-bold text-zinc-400 mb-3">
        {label} {required && <span className="text-amber-400">*</span>}
        {max && (
          <span className="ml-2 text-zinc-500 normal-case tracking-normal">
            {value.length}/{max}
          </span>
        )}
      </p>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const on = value.includes(opt);
          return (
            <button
              type="button"
              key={opt}
              onClick={() => toggle(opt)}
              data-testid={`${testIdPrefix}-${slug(opt)}`}
              aria-pressed={on}
              className={`group inline-flex items-center gap-2 px-3.5 py-2.5 text-[11px] uppercase tracking-[0.18em] font-bold border transition-all duration-200 ${
                on
                  ? "bg-amber-400 text-black border-amber-400 shadow-[0_0_24px_-8px_rgba(251,191,36,0.6)]"
                  : "border-white/10 hover:border-amber-400 hover:bg-amber-400/5 hover:text-amber-400 text-zinc-300 active:scale-95"
              }`}
            >
              <span
                className={`inline-flex h-3.5 w-3.5 items-center justify-center border transition-all ${
                  on
                    ? "bg-black border-black"
                    : "border-zinc-500 group-hover:border-amber-400"
                }`}
                aria-hidden="true"
              >
                {on && <Check className="h-2.5 w-2.5 text-amber-400" strokeWidth={3} />}
              </span>
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}
